/**
 * Tiletopia Sample System Script Tag
 * Handles sample price adjustment and customer validation
 * Place this in theme.liquid or create a script asset
 */

// (function() {
//   // Configuration
//   const config = {
//     sampleProductId: 9401468551466,
//     sampleVariantId: 55698122310016,
//     samplePrice: 199, // £1.99 in pence
//     freeLimit: 2,
//     sampleImage: 'https://cdn.shopify.com/s/files/1/0751/8122/8330/products/Sample_c66c0f22-0a03-4fd0-b508-980a54817b46.jpg?v=1689284858'
//   };
  
//   // Helper functions
//   const utils = {
//     // Get customer tracking data
//     getCustomerData: function() {
//       const customerData = {
//         email: __st.cid || null,
//         id: window.ShopifyAnalytics?.meta?.page?.customerId || null,
//         hasOrdered: localStorage.getItem('tiletopia_sample_ordered') === 'true'
//       };
//       return customerData;
//     },
    
//     // Check if customer is eligible for free samples
//     isEligibleForFreeSamples: async function() {
//       const customerData = this.getCustomerData();
      
//       // Check if customer has already ordered samples
//       if (customerData.hasOrdered) {
//         return false;
//       }
      
//       // If customer is logged in, check order history
//       if (customerData.id) {
//         try {
//           const response = await fetch('/account/orders.json');
//           const orders = await response.json();
          
//           // Check if any previous orders contain samples
//           for (const order of orders.orders || []) {
//             for (const item of order.line_items) {
//               if (item.variant_id == config.sampleVariantId) {
//                 localStorage.setItem('tiletopia_sample_ordered', 'true');
//                 return false;
//               }
//             }
//           }
//         } catch (error) {
//           console.error('Error checking order history:', error);
//         }
//       }
      
//       return true;
//     },
    
//     // Count samples in cart
//     countSamplesInCart: async function() {
//       try {
//         const response = await fetch('/cart.js');
//         const cart = await response.json();
//         let count = 0;
        
//         cart.items.forEach(item => {
//           if (item.variant_id == config.sampleVariantId) {
//             count += item.quantity;
//           }
//         });
        
//         return count;
//       } catch (error) {
//         console.error('Error counting samples:', error);
//         return 0;
//       }
//     },
    
//     // Update sample prices in cart
//     updateSamplePrices: async function() {
//       const sampleCount = await this.countSamplesInCart();
//       const isEligible = await this.isEligibleForFreeSamples();
      
//       if (!isEligible || sampleCount > config.freeLimit) {
//         try {
//           const response = await fetch('/cart.js');
//           const cart = await response.json();
//           const updates = {};
//           let freeSamplesLeft = isEligible ? config.freeLimit : 0;
          
//           cart.items.forEach(item => {
//             if (item.variant_id == config.sampleVariantId) {
//               if (freeSamplesLeft >= item.quantity) {
//                 // Free samples
//                 updates[item.key] = {
//                   properties: {
//                     ...item.properties,
//                     'Sample Type': 'Free',
//                     'Price': '£0.00'
//                   }
//                 };
//                 freeSamplesLeft -= item.quantity;
//               } else if (freeSamplesLeft > 0) {
//                 // Mixed free and paid
//                 const paidCount = item.quantity - freeSamplesLeft;
//                 updates[item.key] = {
//                   properties: {
//                     ...item.properties,
//                     'Sample Type': `${freeSamplesLeft} Free, ${paidCount} Paid`,
//                     'Price': `£${(paidCount * 1.99).toFixed(2)}`
//                   }
//                 };
//                 freeSamplesLeft = 0;
//               } else {
//                 // All paid
//                 updates[item.key] = {
//                   properties: {
//                     ...item.properties,
//                     'Sample Type': 'Paid',
//                     'Price': `£${(item.quantity * 1.99).toFixed(2)}`
//                   }
//                 };
//               }
//             }
//           });
          
//           if (Object.keys(updates).length > 0) {
//             await fetch('/cart/update.js', {
//               method: 'POST',
//               headers: {
//                 'Content-Type': 'application/json',
//               },
//               body: JSON.stringify({ updates })
//             });
//           }
//         } catch (error) {
//           console.error('Error updating sample prices:', error);
//         }
//       }
//     }
//   };
  
//   // Main sample system
//   const sampleSystem = {
//     init: function() {
//       // Listen for cart updates
//       document.addEventListener('cart:updated', () => {
//         utils.updateSamplePrices();
//       });
      
//       // Listen for checkout
//       document.addEventListener('checkout:start', () => {
//         localStorage.setItem('tiletopia_sample_ordered', 'true');
//       });
      
//       // Update prices on page load
//       if (window.location.pathname.includes('/cart')) {
//         utils.updateSamplePrices();
//       }
      
//       // Add sample button handler
//       this.initSampleButtons();
//     },
    
//     initSampleButtons: function() {
//       // This will be called when product pages load
//       document.addEventListener('DOMContentLoaded', () => {
//         const sampleButtons = document.querySelectorAll('.sample-button');
        
//         sampleButtons.forEach(button => {
//           button.addEventListener('click', async (e) => {
//             e.preventDefault();
            
//             const currentCount = await utils.countSamplesInCart();
//             const isEligible = await utils.isEligibleForFreeSamples();
            
//             if (!isEligible && currentCount === 0) {
//               alert('You have already used your free sample allowance. Additional samples will cost £1.99 each.');
//             }
            
//             // Let the main button handler continue
//           });
//         });
//       });
//     }
//   };
  
//   // Initialize the system
//   sampleSystem.init();
  
//   // Expose utility functions for debugging
//   window.TiletopiaSampleSystem = {
//     utils,
//     config,
//     checkEligibility: utils.isEligibleForFreeSamples,
//     countSamples: utils.countSamplesInCart,
//     updatePrices: utils.updateSamplePrices
//   };
// })();


/**
 * Tiletopia Sample System Script Tag - Fixed Version
 * Handles sample tracking without order history API
 */

(function() {
  // Configuration
  const config = {
    freeVariantId: 'YOUR_FREE_VARIANT_ID', // Replace with your free variant ID
    paidVariantId: 'YOUR_PAID_VARIANT_ID', // Replace with your paid variant ID
    freeLimit: 2
  };
  
  // Helper functions
  const utils = {
    // Use local storage to track if customer has used free samples
    hasUsedFreeSamples: function() {
      return localStorage.getItem('tiletopia_free_samples_used') === 'true';
    },
    
    // Mark free samples as used
    markFreeSamplesUsed: function() {
      localStorage.setItem('tiletopia_free_samples_used', 'true');
    },
    
    // Count samples in cart
    countSamplesInCart: async function() {
      try {
        const response = await fetch('/cart.js');
        const cart = await response.json();
        let freeCount = 0;
        let paidCount = 0;
        
        cart.items.forEach(item => {
          if (item.variant_id == config.freeVariantId) {
            freeCount += item.quantity;
          }
          if (item.variant_id == config.paidVariantId) {
            paidCount += item.quantity;
          }
        });
        
        return { freeCount, paidCount, total: freeCount + paidCount };
      } catch (error) {
        console.error('Error counting samples:', error);
        return { freeCount: 0, paidCount: 0, total: 0 };
      }
    },
    
    // Check if customer can get free samples
    canGetFreeSamples: async function() {
      // If already used free samples (stored in localStorage)
      if (this.hasUsedFreeSamples()) {
        return false;
      }
      
      // Check current cart
      const { freeCount } = await this.countSamplesInCart();
      return freeCount < config.freeLimit;
    }
  };
  
  // Main sample system
  const sampleSystem = {
    init: function() {
      // Listen for checkout to mark free samples as used
      if (window.Shopify && window.Shopify.Checkout) {
        // Mark as used when reaching checkout
        this.markFreeSamplesUsed();
      }
      
      // Also mark as used when order is confirmed (if possible)
      if (window.location.pathname.includes('/thank_you') || 
          window.location.pathname.includes('/orders/')) {
        this.markFreeSamplesUsed();
      }
    },
    
    markFreeSamplesUsed: async function() {
      const { freeCount } = await utils.countSamplesInCart();
      if (freeCount > 0) {
        utils.markFreeSamplesUsed();
      }
    }
  };
  
  // Initialize the system
  sampleSystem.init();
  
  // Expose utility functions for debugging
  window.TiletopiaSampleSystem = {
    utils,
    config,
    checkEligibility: utils.canGetFreeSamples,
    countSamples: utils.countSamplesInCart,
    resetFreeSamples: function() {
      localStorage.removeItem('tiletopia_free_samples_used');
    }
  };
})();